import axios from 'modules/api-client/request';
import { handleAmazonMessage } from 'modules/api-client/response';

import type {
  ICoupon,
  IGetCouponsRequest,
  IDeleteCouponsRequest,
  ICreateCouponsRequest,
  IUpdateCouponActivityRequest,
  IUpdateCouponRequest,
  IGetCouponByIdRequest,
} from './types';
import type { IMetaResponse } from '../types';
import type { IListMeta } from 'models/types';

export const getCourseCouponsRequest = ({ courseId, ...params }: IGetCouponsRequest) => {
  return axios
    .get<void, IMetaResponse<ICoupon[], IListMeta>>(`/admin/courses/${courseId}/coupon`, { params })
    .catch(handleAmazonMessage);
};

export const getCourseCouponByIdRequest = ({ courseId, couponId }: IGetCouponByIdRequest) => {
  return axios.get<void, ICoupon>(`/admin/courses/${courseId}/coupon/${couponId}`).catch(handleAmazonMessage);
};

export const createCourseCouponsRequest = ({ courseId, data }: ICreateCouponsRequest) => {
  return axios.post<ICoupon, ICoupon>(`/admin/courses/${courseId}/coupon`, data).catch(handleAmazonMessage);
};

export const updateCourseCouponRequest = ({ courseId, couponId, data }: IUpdateCouponRequest) => {
  return axios.put<ICoupon, ICoupon>(`/admin/courses/${courseId}/coupon/${couponId}`, data).catch(handleAmazonMessage);
};

export const batchUpdateCourseCouponsRequest = ({ courseId, data }: IUpdateCouponActivityRequest) => {
  return axios
    .post<void, Omit<IUpdateCouponActivityRequest, 'courseId'>>(`/admin/courses/${courseId}/coupon/batch-update`, data)
    .catch(handleAmazonMessage);
};

export const batchDeleteCourseCouponsRequest = ({ courseId, data }: IDeleteCouponsRequest) => {
  return axios
    .post<void, Omit<IDeleteCouponsRequest, 'courseId'>>(`/admin/courses/${courseId}/coupon/batch-delete`, data)
    .catch(handleAmazonMessage);
};

